import React, { useState, useEffect } from "react";
import axios from "axios";
import { Glasses, ChevronRight, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CatalogoLojas() {
  const [lojas, setLojas] = useState(null);
  const [empresa, setEmpresa] = useState("");

  useEffect(() => {
    const t = new URLSearchParams(window.location.search).get("t");
    axios.get(`${API}/catalogo/lojas`, { params: t ? { t } : {} })
      .then((r) => { setLojas(r.data.lojas || []); setEmpresa(r.data.empresa || ""); })
      .catch(() => setLojas([]));
  }, []);

  return (
    <div className="h-[100dvh] overflow-y-auto bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex flex-col items-center px-5 py-12" data-testid="catalogo-lojas-lp">
      <div className="w-16 h-16 rounded-full bg-white text-slate-900 flex items-center justify-center shadow-xl mb-5">
        <Glasses className="w-9 h-9" />
      </div>
      <h1 className="text-3xl font-extrabold text-white text-center tracking-tight" data-testid="lp-empresa">{empresa || "Catálogo Digital"}</h1>
      <p className="text-slate-300 text-sm text-center mt-2 mb-8 max-w-sm">
        Escolha a loja para ver o catálogo exclusivo de armações e óculos de sol.
      </p>

      <div className="w-full max-w-md space-y-3">
        {lojas === null && (
          <div className="flex justify-center py-10"><Loader2 className="w-7 h-7 animate-spin text-slate-400" /></div>
        )}
        {lojas && lojas.length === 0 && (
          <p className="text-center text-slate-400 py-8">Nenhuma loja disponível no momento.</p>
        )}
        {lojas && lojas.map((l) => (
          <a
            key={l.slug}
            href={`/catalogo/${l.slug}`}
            data-testid={`lp-loja-${l.slug}`}
            className="group flex items-center justify-between gap-3 bg-white hover:bg-slate-50 rounded-2xl px-5 py-4 shadow-lg transition-all hover:scale-[1.02] active:scale-[0.99]"
          >
            <span className="flex items-center gap-3 min-w-0">
              <span className="w-10 h-10 rounded-full bg-slate-900 text-white flex items-center justify-center shrink-0">
                <Glasses className="w-5 h-5" />
              </span>
              <span className="min-w-0">
                <span className="block font-bold text-slate-900 truncate">{l.nome}</span>
                <span className="block text-xs text-slate-400">Ver catálogo</span>
              </span>
            </span>
            <ChevronRight className="w-5 h-5 text-slate-300 group-hover:text-slate-900 transition-colors" />
          </a>
        ))}
      </div>

      <p className="text-[11px] text-slate-500 mt-10">© Óticas Laurindo</p>
    </div>
  );
}
